import type {InputAttrs} from '@jetbrains/ring-ui/components/input/input'
import RingInput from '@jetbrains/ring-ui/components/input/input'
import classNames from 'classnames'
import {memo} from 'react'

import styles from './Input.css'

function Input({inputClassName, ...props}: InputAttrs) {
  const inputClassNames = classNames(styles.input, inputClassName)

  return <RingInput inputClassName={inputClassNames} {...props} />
}

export default memo<InputAttrs>(Input)
